import { render } from "./contact.vue?vue&type=template&id=c499f5f6&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=c499f5f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c499f5f6"

export default script